const FILL = { W: "#F8F3D4", U: "#AFCFEA", B: "#BDB4AE", R: "#EE9F7E", G: "#9CCFA8", C: "#CDC4C1" };
const GENERIC = "#CAC5C0";
const INK = "#16130F";
const COLORED = "WUBRG";

function Glyph({ k, bg = GENERIC, ink = INK }) {
  switch (k) {
    case "W": return <g fill={ink}><circle cx="12" cy="12" r="3.1" />{[0, 45, 90, 135, 180, 225, 270, 315].map((a) => <path key={a} d="M12 4.6l1 2.7h-2z" transform={`rotate(${a} 12 12)`} />)}</g>;
    case "U": return <path fill={ink} d="M12 5.2c0 0-4.6 5.3-4.6 8.5a4.6 4.6 0 0 0 9.2 0C16.6 10.5 12 5.2 12 5.2z" />;
    case "B": return <g><path fill={ink} d="M12 5.4a5.6 5.6 0 0 0-5.6 5.6c0 2 1 3.3 2.3 4V17.4h6.6V15c1.3-.7 2.3-2 2.3-4A5.6 5.6 0 0 0 12 5.4z" /><circle cx="9.8" cy="11.2" r="1.3" fill={bg} /><circle cx="14.2" cy="11.2" r="1.3" fill={bg} /><path d="M11.1 17.4v-1.6M12.9 17.4v-1.6" stroke={bg} strokeWidth=".7" /></g>;
    case "R": return <path fill={ink} d="M12.2 4.8c.4 2.6 4.1 4 4.1 8a4.3 4.3 0 0 1-8.6.1c0-1.9 1-2.9 1.8-3.7.1 1.3.8 2.1 1.5 2.3-.6-2.3-.1-4.6 1.2-6.7z" />;
    case "G": return <path fill={ink} d="M12 4.8l-4.8 6.1h2.3L6.8 15h4.4v3.2h1.6V15h4.4l-2.7-4.1h2.3z" />;
    case "C": return <path fill="none" stroke={ink} strokeWidth="1.6" d="M12 6l5 6-5 6-5-6z" />;
    case "S": return <g stroke={ink} strokeWidth="1.5" strokeLinecap="round">{[0, 60, 120].map((a) => <path key={a} d="M12 6v12M10.3 7.3L12 9l1.7-1.7M10.3 16.7L12 15l1.7 1.7" transform={`rotate(${a} 12 12)`} fill="none" />)}</g>;
    case "T": return <g fill="none" stroke={ink} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M8.2 17.5V10a2.8 2.8 0 0 1 2.8-2.8h4.6" /><path d="M13.8 4.8l2.4 2.4-2.4 2.4" /></g>;
    case "Q": return <g fill="none" stroke={ink} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M15.8 6.5V14a2.8 2.8 0 0 1-2.8 2.8H8.4" /><path d="M10.2 19.2l-2.4-2.4 2.4-2.4" /></g>;
    case "E": return <path fill={ink} d="M13.3 4.8L7.9 13h3.6L10.4 19.2 16.1 10.6h-3.6z" />;
    case "P": return <g fill="none" stroke={ink} strokeWidth="1.6"><ellipse cx="12" cy="12" rx="3.6" ry="3.2" /><path d="M12 5.6v12.8" /></g>;
    default: return <text x="12" y={k.length > 1 ? 15.4 : 16.1} textAnchor="middle" fontSize={k.length > 1 ? 9 : 11.5} fontWeight="700" fontFamily="Georgia, 'Times New Roman', serif" fill={ink}>{k}</text>;
  }
}

const fillFor = (k) => FILL[k] || GENERIC;

/** One mana / game symbol such as W, 2/U, G/P, T or 10, drawn as an inline SVG. */
export function ManaSymbol({ sym, size = 16, className = "" }) {
  const raw = String(sym).toUpperCase().replace(/[{}]/g, "");
  const parts = raw.split("/").filter(Boolean);
  const common = { width: size, height: size, viewBox: "0 0 24 24", role: "img", "aria-label": `{${raw}}`, className: `inline-block shrink-0 align-[-0.18em] ${className}` };
  const ring = <circle cx="12" cy="12" r="10.6" fill="none" stroke="rgba(0,0,0,.45)" strokeWidth=".8" />;
  if (parts.length >= 2 && parts[1] === "P" && COLORED.includes(parts[0])) {
    return <svg {...common}><circle cx="12" cy="12" r="11" fill={fillFor(parts[0])} /><Glyph k="P" bg={fillFor(parts[0])} />{ring}</svg>;
  }
  if (parts.length >= 2) {
    const [a, b] = parts;
    return (
      <svg {...common}>
        <path d="M4.2 19.8A11 11 0 0 1 19.8 4.2z" fill={fillFor(a)} />
        <path d="M19.8 4.2A11 11 0 0 1 4.2 19.8z" fill={fillFor(b)} />
        <g transform="translate(2.6 2.6) scale(.55)"><Glyph k={a} bg={fillFor(a)} /></g>
        <g transform="translate(8.2 8.2) scale(.55)"><Glyph k={b} bg={fillFor(b)} /></g>
        {parts[2] === "P" && <path d="M12 9.5v5" stroke={INK} strokeWidth=".9" />}
        {ring}
      </svg>
    );
  }
  const k = parts[0] || "";
  const untap = k === "Q";
  const bg = untap ? "#1E1B18" : fillFor(k);
  return <svg {...common}><circle cx="12" cy="12" r="11" fill={bg} /><Glyph k={k} bg={bg} ink={untap ? "#F2EEE6" : INK} />{ring}</svg>;
}

/** Rules text with every {X} code shown as a mana symbol. */
export function ManaText({ text, size = "1.05em" }) {
  if (!text) return null;
  return String(text).split(/(\{[^}]{1,8}\})/g).map((part, i) => (/^\{[^}]+\}$/.test(part) ? <ManaSymbol key={i} sym={part} size={size} className="mx-[0.06em]" /> : part));
}
